import { zetApi } from '@zet/network'

import { VerifyPhoneParams } from '../types'

export async function verifyPhoneNumber({
  phoneNumber,
  utmAttributes,
}: VerifyPhoneParams) {
  try {
    if (phoneNumber) {
      const response = await zetApi.post(`/signup/generate_otp/v4`, {
        phoneNumber: `91${phoneNumber}`,
        utmAttributes,
      })
      return response
    } else {
      throw new Error('Invalid Phone Number!')
    }
  } catch (error) {
    return error
  }
}
